<div class="page-container">
  <!-- LEFT COLUMN -->
  <div class="column left" *ngIf="deviceInfo.deviceTypeDetected === 'DESKTOP'">
    <div class="texts-container">
      <h1 class="main-title-text" [innerHTML]="'LOGIN_PAGE.MAIN_TITLE' | translate: {}"></h1>
      <h3 class="subtitle-text" [innerHTML]="'LOGIN_PAGE.SUBTITLE' | translate: {}"></h3>
    </div>
  </div>

  <!-- RIGHT COLUMN -->
  <ng-container *ngIf="APIAvailable">
    <div class="column right" *ngIf="currentUserLang?.key; else userLangLoader">
      <div class="utils-buttons-wrapper">
        <app-utils-buttons></app-utils-buttons>
      </div>

      <!-- FORM -->
      <div class="content-column">
        <div nz-row>
          <div nz-col [nzSpan]="24">
            <div class="graphic-dot"></div>
          </div>
        </div>
        <div nz-row>
          <div nz-col [nzSpan]="24">
            <div class="form-title">
              {{ 'ACTIVATE_ACCOUNT_PAGE.SET_PASSWORD_AND_ACTIVATE_ACCOUNT' | translate }}
            </div>
          </div>
        </div>
        <form nz-form [formGroup]="form" class="activate-account-form">
          <nz-form-item [class.has-hint]="!form.controls.password.dirty">
            <nz-form-label [nzSpan]="24" nzRequired nzFor="activateAccountPassword">
              {{ 'COMMON.LABEL.PASSWORD' | translate }}
            </nz-form-label>
            <nz-form-control [nzSpan]="24" nzErrorTip="{{ 'ACTIVATE_ACCOUNT_PAGE.INVALID_PASSWORD' | translate }}">
              <nz-input-group [nzSuffix]="suffixTemplate">
                <input
                  nz-input
                  id="activateAccountPassword"
                  [type]="isPasswordVisible ? 'text' : 'password'"
                  (focus)="scrollToInput($event)"
                  formControlName="password"
                  placeholder="{{ 'COMMON.PLACEHOLDER.ENTER_PASSWORD' | translate }}"
                  required />
              </nz-input-group>
              <ng-template #suffixTemplate>
                <button
                  type="button"
                  class="toggle-password-btn"
                  tabindex="-1"
                  [attr.aria-label]="'ACTIVATE_ACCOUNT_PAGE.SHOW_HIDE_PASSWORD' | translate"
                  (click)="isPasswordVisible = !isPasswordVisible">
                  <i nz-icon [nzType]="isPasswordVisible ? 'eye-invisible' : 'eye'"></i>
                </button>
              </ng-template>
              <div class="hint" *ngIf="!form.controls.password.dirty">
                {{ 'ACTIVATE_ACCOUNT_PAGE.PASSWORD_HINT' | translate }}
              </div>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="24" nzRequired nzFor="activateAccountPasswordConfirmation">
              {{ 'COMMON.LABEL.CONFIRM_PASSWORD' | translate }}
            </nz-form-label>
            <nz-form-control
              [nzSpan]="24"
              nzErrorTip="{{ 'ACTIVATE_ACCOUNT_PAGE.INVALID_PASSWORD_CONFIRMATION' | translate }}">
              <nz-input-group [nzSuffix]="suffixConfirmTemplate">
                <input
                  nz-input
                  id="activateAccountPasswordConfirmation"
                  [type]="isPasswordConfirmVisible ? 'text' : 'password'"
                  (focus)="scrollToInput($event)"
                  formControlName="passwordConfirmation"
                  placeholder="{{ 'COMMON.PLACEHOLDER.ENTER_CONFIRM_PASSWORD' | translate }}"
                  required />
              </nz-input-group>
              <ng-template #suffixConfirmTemplate>
                <button
                  type="button"
                  class="toggle-password-btn"
                  tabindex="-1"
                  [attr.aria-label]="'ACTIVATE_ACCOUNT_PAGE.SHOW_HIDE_PASSWORD' | translate"
                  (click)="isPasswordConfirmVisible = !isPasswordConfirmVisible">
                  <i nz-icon [nzType]="isPasswordConfirmVisible ? 'eye-invisible' : 'eye'"></i>
                </button>
              </ng-template>
            </nz-form-control>
          </nz-form-item>

          <!-- Pin -->
          <ng-container *ngIf="pinRequired">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzRequired nzFor="activateAccountPIN">
                {{ 'ACTIVATE_ACCOUNT_PAGE.PIN' | translate }}
              </nz-form-label>
              <nz-form-control [nzSpan]="24" nzErrorTip="{{ 'COMMON.ERROR.WRONG_PIN' | translate }}">
                <input
                  nz-input
                  id="activateAccountPIN"
                  type="password"
                  (focus)="scrollToInput($event)"
                  formControlName="pin"
                  placeholder="PIN"
                  autocomplete="off"
                  required />
              </nz-form-control>
            </nz-form-item>
          </ng-container>

          <!-- GDPR & Data processing -->
          <ng-container *ngIf="gapRequired">
            <nz-form-item class="terms-form-item">
              <nz-form-label
                class="terms-label"
                [nzXs]="22"
                [nzSm]="22"
                [nzSpan]="22"
                [nzNoColon]="true"
                nzRequired
                nzFor="hasAcceptedGDPR">
                <p class="label-text">
                  {{ 'ACTIVATE_ACCOUNT_PAGE.TOS_GDPR_ACCEPTANCE.STEP_1_CONFIRM' | translate }}
                  <a target="_blank" rel="noopener" [href]="'COMMON.LINKS.TOS' | translate">
                    {{ 'ACTIVATE_ACCOUNT_PAGE.TOS_GDPR_ACCEPTANCE.TOS' | translate }}
                  </a>
                  {{ 'ACTIVATE_ACCOUNT_PAGE.TOS_GDPR_ACCEPTANCE.STEP_2_OR' | translate }}
                  <a target="_blank" rel="noopener" [href]="'COMMON.LINKS.PRIVACY_POLICY' | translate">
                    {{ 'ACTIVATE_ACCOUNT_PAGE.TOS_GDPR_ACCEPTANCE.PRIVACY_POLICY' | translate }}
                  </a>
                  {{ 'ACTIVATE_ACCOUNT_PAGE.TOS_GDPR_ACCEPTANCE.STEP_3_ACCEPT' | translate }}
                </p>
              </nz-form-label>
              <nz-form-control [nzSpan]="2" [nzXs]="2" [nzSm]="2">
                <label nz-checkbox name="hasAcceptedGDPR" formControlName="hasAcceptedGDPR" required> </label>
              </nz-form-control>
            </nz-form-item>

            <nz-form-item class="terms-form-item">
              <nz-form-label
                class="terms-label complex"
                [nzNoColon]="true"
                [nzSpan]="22"
                nzRequired
                nzFor="hasAcceptedDataProcessing">
                <div class="label-text">
                  {{
                    termsAcceptanceShownFully
                      ? ('ACTIVATE_ACCOUNT_PAGE.DATA_PROCESSING_ACCEPTANCE' | translate)
                      : ('ACTIVATE_ACCOUNT_PAGE.DATA_PROCESSING_ACCEPTANCE_SHORT' | translate)
                  }}
                  <span
                    *ngIf="!termsAcceptanceShownFully"
                    class="suffix-text"
                    (click)="termsAcceptanceShownFully = !termsAcceptanceShownFully"
                    [innerHTML]="'ACTIVATE_ACCOUNT_PAGE.SHOW_FULL_ACCEPTANCE_CONTENT' | translate"></span>
                </div>
              </nz-form-label>
              <nz-form-control [nzSpan]="2">
                <label
                  nz-checkbox
                  name="hasAcceptedDataProcessing"
                  formControlName="hasAcceptedDataProcessing"
                  required>
                </label>
              </nz-form-control>
            </nz-form-item>
          </ng-container>

          <!-- Submit button -->
          <div nz-row>
            <div nz-col [nzSpan]="24">
              <button
                (click)="submitForm()"
                class="submit-button"
                id="activateAccountSubmitButton"
                [disabled]="form.pristine || (form.dirty && form.invalid) || (loading$ | async)"
                mat-raised-button
                color="primary">
                {{ 'ACTIVATE_ACCOUNT_PAGE.ACTIVATE_ACCOUNT' | translate }}
              </button>
            </div>
          </div>
          <div class="error-message-container" *ngIf="form.get('passwordConfirmation')?.dirty && form.errors?.noMatch">
            {{ 'ACTIVATE_ACCOUNT_PAGE.PASSWORDS_DO_NOT_MATCH' | translate }}
          </div>
          <div
            *ngIf="errorMessage$ | async as errorMessage"
            [ngSwitch]="errorMessage"
            #errorMessageContainer
            class="error-message-container">
            <div *ngSwitchCase="'COMMON.ERROR.USER_IS_ALREADY_ACTIVE'">
              <div
                class="main-error-message"
                [innerHTML]="'ACTIVATE_ACCOUNT_PAGE.ERRORS.USER_IS_ALREADY_ACTIVE' | translate"></div>
              <div class="error-links">
                <a (click)="$event.preventDefault()" [routerLink]="['/login']">
                  {{ 'COMMON.REDIRECT.GO_TO_LOGIN' | translate }}
                </a>
                &nbsp;|&nbsp;
                <a (click)="$event.preventDefault()" [routerLink]="['/reset-password']">
                  {{ 'COMMON.REDIRECT.GO_TO_PASSWORD_RESET' | translate }}
                </a>
              </div>
            </div>
            <div *ngSwitchCase="'COMMON.ERROR.WRONG_PIN'">
              <div class="main-error-message" [innerHTML]="'COMMON.ERROR.WRONG_PIN' | translate"></div>
            </div>
            <div *ngSwitchCase="'COMMON.ERROR.UNAUTHORIZED'">
              <div
                class="main-error-message"
                [innerHTML]="'ACTIVATE_ACCOUNT_PAGE.ERRORS.UNAUTHORIZED' | translate"></div>
              <div class="error-explanations">
                <ul>
                  <li [innerHTML]="'ACTIVATE_ACCOUNT_PAGE.CHECK_EMAIL_WITH_LINK' | translate"></li>
                  <li [innerHTML]="'ACTIVATE_ACCOUNT_PAGE.ACTIVATION_LINK_EXPIRATION' | translate"></li>
                  <li [innerHTML]="'ACTIVATE_ACCOUNT_PAGE.IF_DATE_VALID_THEN_LINK_WRONG' | translate"></li>
                  <li [innerHTML]="'ACTIVATE_ACCOUNT_PAGE.IF_DATE_VALID_THEN_LINK_WRONG_2' | translate"></li>
                  <li [innerHTML]="'ACTIVATE_ACCOUNT_PAGE.CONTACT_US' | translate"></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="loading-container" *ngIf="loading$ | async">
            <mat-spinner [diameter]="35"></mat-spinner>
          </div>
        </form>
      </div>
    </div>
    <ng-template #userLangLoader>
      <div class="column right">
        <mat-spinner [diameter]="40"></mat-spinner>
      </div>
    </ng-template>
  </ng-container>
  <ng-container *ngIf="!APIAvailable">
    <div class="column right extra-space">
      <div class="utils-buttons-wrapper">
        <app-utils-buttons></app-utils-buttons>
      </div>
      <div class="content-column extra-space">
        <div class="form-title error-title">
          {{ 'COMMON.ERROR.NO_CONNECTION_WITH_SERVER' | translate }}
        </div>
        <div class="connection-error-block">
          <div class="subtitle" [innerHTML]="'COMMON.ERROR.CONNECTION_ERROR_EXPLANATION' | translate"></div>
          <ul>
            <li [innerHTML]="'COMMON.NOTIFICATION.WAIT_WE_WILL_TRY_TO_RECONNECT' | translate"></li>
            <li [innerHTML]="'COMMON.NOTIFICATION.CHECK_INTERNET_CONNECTION' | translate"></li>
            <li [innerHTML]="'COMMON.NOTIFICATION.CHECK_FIREWALL_SETTINGS' | translate"></li>
            <li [innerHTML]="'COMMON.NOTIFICATION.CONSULT_LOCAL_NETWORK_ADMIN' | translate"></li>
            <li [innerHTML]="'COMMON.NOTIFICATION.COMEBACK_LATER' | translate"></li>
          </ul>
        </div>
      </div>
    </div>
  </ng-container>
</div>
